import { render, staticRenderFns } from "./RvsTrendGraph.vue?vue&type=template&id=f4c322f8&scoped=true"
import script from "./RvsTrendGraph.vue?vue&type=script&lang=ts"
export * from "./RvsTrendGraph.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4c322f8",
  null
  
)

export default component.exports